<template>
    <div class="fill-height of-y d-flex flex-column">
        <div class="flex-grow-0 pa-2 d-flex justify-space-between align-center">
            <div>
                <v-btn
                    color="primary"
                    small
                    :loading="loading"
                    :disabled="loading"
                    @click="refreshReportData"
                    class="mr-2"
                >
                    Refresh
                </v-btn>
                <v-btn
                        :disabled="false"
                        @click="exportData"
                        color="primary"
                        small
                        :loading="exportingData"
                        class="mr-2"
                >
                    Export
                </v-btn>
              <v-btn
                small
                color="primary"
                @click="createWarningShow = !createWarningShow"
                v-if="user.adminOptions.issueWarrants || user.adminOptions.setup || user.adminOptions.users"
              >
                <v-icon left>mdi-alert</v-icon>
                Issue Warning Warrants
              </v-btn>
            </div>
            <div style="width: 30%">
                <v-text-field
                        v-model="search"
                        prepend-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        class="pa-0 ma-0"
                ></v-text-field>
            </div>
        </div>
        <div class="flex-grow-1 of-y">

            <div class="fill-height d-flex align-center justify-center" v-if="loading">
                <loader></loader>
            </div>

            <v-data-table
                    v-else
                    :search="search"
                    dense
                    fixed-header
                    height="100%"
                    class="fill-height of-y"
                    hide-default-footer
                    :headers="headers"
                    :items="rows"
                    :options="{itemsPerPage: rows.length}"
            >
                <template #item.issued="{item}">{{format(new Date(item.issued), 'yyyy-MM-dd hh:mm')}}</template>
            </v-data-table>
        </div>

      <create-warings
        v-if="createWarningShow"
        v-model="createWarningShow"
      />
    </div>
</template>

<script>

import {mapGetters} from "vuex";
import {format} from "date-fns";
import Loader from "@/components/General/Loader/Loader.vue";
import {exportStats} from "@/core/codeFunctions";
import CreateWarings from "@/components/Setup/Emp/Warnings/CreateWarings.vue";

export default {
    components: {CreateWarings, Loader},
    props: {
        reportType: String,
        selectedFarm: Number,
        selectedDate: Date
    },
    data() {
        return {
            format,
            exportingData: false,
            search: null,
            headers: [

                {value: "farm", text: "Farm"},
                {value: "warning", text: "Warning"},
                {value: "offenceTitle", text: "Title"},
                {value: "dateOfOffence", text: "Offence Date"},
                {value: "offenceNo", text: "Offence No."},
                {value: "issued", text: "Issued"},
                {value: "age", text: "Age"},
                {value: "empCode", text: "Clock No"},
                {value: "fullName", text: "Name"},
                {value: "idNo", text: "Id/Passport No."},
                {value: "employeeStatus", text: "Employee Status"},
                // {value: "status", text: "Status"},
                // {value: "signedDate", text: "SignedDate"},
                // {value: "signedLocation", text: "SignedLocation"},
                // {value: "fkSignedDoc", text: "FkSignedDoc"},
                // {value: "fkSignature", text: "FkSignature"},
                {value: "issuedBy", text: "Issued By"},
                // {value: "lastModifiedBy", text: "LastModifiedBy"},
                // {value: "modified", text: "Modified"},
                // {value: "fkFarm", text: "FkFarm"},
                // {value: "fkEmp", text: "FkEmp"},
            ],
            loading: false,
            data: [],
          createWarningShow: false
        }
    },

    mounted() {
        this.refreshReportData();
    },

    methods: {

        async refreshReportData() {
            try {
                this.loading = true
                this.data = await this.$newReq('POST', 'reports/warnings/outstanding', {})
            } catch (e) {
                console.log(e)
            } finally {
                this.loading = false
            }

        },

        exportData() {
            const data = this.rows.map(row => {
                return {
                    ...row,
                    issued: format(new Date(row.issued), 'yyyy-MM-dd hh:mm')
                }
            });

            exportStats(`Outstanding Warrants${this.selectedFarm ? ' for ' + this.farmsRef[this.selectedFarm].description + ' ' : ''} ${format(Date.now(), 'yyyy-MM-dd hh_mm')}`, 'Warrants', this.headers, data)
        },
    },
    computed: {
        ...mapGetters(["farms", "availableFarms", "availableFarmIDs", "farmsRef", "user"]),
        rows() {
            return this.data
                    .filter((row) => row && this.selectedFarm ? row.fkFarm === this.selectedFarm : true)
                    .filter(row => row.farmID ? this.availableFarmIDs.includes(row.farmID) : true)
        }
    },
}
</script>

<style scoped>

</style>